export enum SourceClassification {
  PaidSubscription = 'PaidSubscription',
  GiftedAnnualSubscription = 'GiftedAnnualSubscription',
  FreeSubscription = 'FreeSubscription',
  MigratedSubscription = 'MigratedSubscription',
  BulkUpdateSubscription = 'BulkUpdateSubscription',
  TrialSubscription = 'TrialSubscription',
}
